var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-avatar',{attrs:{"src":_vm.company.logo,"text":_vm.avatarText(_vm.company.name),"size":_vm.size,"rounded":""},on:{"click":function($event){return _vm.$refs.refInputEl.click()}}})}
var staticRenderFns = []

export { render, staticRenderFns }